<div class="p-x-1">
  <h1 class="mat-h1" *ngIf="title">{{ title }}</h1>
  <p *ngIf="subtitle">{{ subtitle }}</p>

  <div class="row row-jc-e gap-1">
    <button
      mat-button
      (click)="onNoClicked()"
    >{{ 'shared.no' | translate }}</button>

    <button
      mat-raised-button
      color="primary"
      (click)="onYesClicked()"
    >{{ 'shared.yes' | translate }}</button>
  </div>
</div>